import { EmployeeGiftInvestmentDto } from "../app/model/api/types/dto";

export class EmployeePledgeGiftInvestmentViewModel {
  id: string | null | undefined;
  giftInvestment: string | null | undefined;
  giftInvestmentId: string | null | undefined;
  employeePledgeId: string | null | undefined;
  agencyId: string | null | undefined;
  pledgeAmount: number | null | undefined;
  otherAgencyName: string | null;
  isDropdown: boolean | null | undefined;

  constructor(
    id: string | null | undefined,
    giftInvestment: string | null | undefined,
    giftInvestmentId: string | null | undefined,
    employeePledgeId: string | null | undefined,
    agencyId: string | null | undefined,
    pledgeAmount: number | null | undefined,
    otherAgencyName: string | null,
    isDropdown: boolean | null | undefined,
  ) {
    this.id = id;
    this.giftInvestment = giftInvestment;
    this.giftInvestmentId = giftInvestmentId;
    this.employeePledgeId = employeePledgeId;
    this.agencyId = agencyId;
    this.pledgeAmount = pledgeAmount;
    this.otherAgencyName = otherAgencyName;
    this.isDropdown = isDropdown;
  }

  toDto(): EmployeeGiftInvestmentDto {
    return {
      id: this.id,
      giftInvestmentId: this.giftInvestmentId,
      employeePledgeId: this.employeePledgeId,
      agencyId: this.agencyId,
      pledgeAmount: this.pledgeAmount,
      otherAgencyName: this.otherAgencyName,
      isDropDown: this.isDropdown,
    };
  }

  public static mapFromDto(
    dto: EmployeeGiftInvestmentDto | null | undefined
  ): EmployeePledgeGiftInvestmentViewModel | null {
    if (dto === null || dto === undefined) {
      return null;
    }

    return new EmployeePledgeGiftInvestmentViewModel(
      dto.id,
      "",
      dto.giftInvestmentId,
      dto.employeePledgeId,
      dto.agencyId,
      dto.pledgeAmount,
      dto.otherAgencyName,
      dto.isDropDown
    );
  }
}
